<template>
    <div class="home">
        <h1>PUBG 一键作图</h1>
        <div class="tips">免费无隐患</div>
        <div class="search-box">
            <div></div>
            <input
                type="text"
                class="search-input"
                placeholder="请输入您要估值的steam账号17位ID"
                v-model="steam"
            />
            <button class="search-btn" @click="preview">确定</button>
        </div>
        <div style="margin-top: 10px;">
			<a target="_blank" href="https://www.weilaiwangluo.com/game_news/41.html" class="how">
				如何获取steam账号的17位ID？
			</a>
		</div>

        <div class="create" v-show="showCreate">
            <div class="bg-box">
                <div
                    class="btn-item"
                    :class="{ disable: pageIndex <= 1 }"
                    style="margin-right: 20px"
                    @click="
                        () =>
                            (pageIndex =
                                pageIndex <= 1 ? pageIndex : pageIndex - 1)
                    "
                >
                    上一页
                </div>
                <img
                    v-for="(item, index) of bgList"
                    :key="index"
                    :src="item"
                    @click="() => (bg = `url(${item})`)"
                />
                <div
                    class="btn-item"
                    :class="{ disable: pageIndex >= 5 }"
                    style="margin-left: 20px"
                    @click="
                        () =>
                            (pageIndex =
                                pageIndex >= 5 ? pageIndex : pageIndex + 1)
                    "
                >
                    下一页
                </div>
            </div>
            <div class="create-l">
                <div class="btn-item">
                    <colorPicker v-model="color"></colorPicker>
                </div>
                <div class="btn-item">
                    上传背景图
                    <input
                        type="file"
                        @change="uploadImg($event)"
                        class="uploadimg"
                    />
                </div>
                <div class="btn-item" @click="() => (editLevel = true)">
                  武器等级
                </div>
                <div class="btn-item" @click="changeBgStyle">
                    背景样式 ({{ bgStyle === 1 ? "贯穿式" : "单一式" }})
                </div>
                <div class="btn-item" @click="() => (sendVal = true)">
                    添加描述
                </div>
                <div class="btn-item" @click="() => (pubgList = [])">
                    删除通行证展示
                </div>
                <div
                    class="btn-item"
                    v-if="iconIsFinish && !showloading && !showCreateLoading"
                    @click="creatImg()"
                >
                    生成图片
                </div>
                <div v-else-if="showCreateLoading" class="btn-item disable">
                    图片生成中
                    <div class="loader-01"></div>
                </div>
                <div class="btn-item disable" v-else>
                    资源加载中
                    <div class="loader-01"></div>
                </div>
            </div>
            <div
                ref="capture"
                class="create-r"
                :style="bodyStyle">
				
                <div class="kpw">
                    <span class="scdj-text">
                        可 排 位
                    </span>
                </div>
				<div class="scdj" v-if="showScdj">
					<span class="scdj-text">
						生存等级500级
					</span>
				</div>
                <div v-if="pubgList.length > 0" class="pubg">
                    <img v-for="img in pubgList" :key="img" :src="img" class="txz-image"/>
                </div>
                <div style="height: 40px;"></div>
                <div class="text-content">
                    <div v-if="false">
                        可在Steam市场出售的库存价值：{{ valuation }}元
                    </div>
                    <div v-if="descVal">{{ descVal }}</div>
                </div>
                <div style="height: 60px;"></div>
                <draggable v-model="List" style="z-index: 1;">
                    <transition-group name="flip-list" class="preview">
                        <div
                            v-for="index of List.length > canDriveCount? canDriveCount: List.length"
                            :key="index"
                            class="imgblock "
                            :class="{active:List[index - 1]==selected}"
                            @click="changeImage(List[index - 1])"
                        >
                            <img
                                @load="computeLoadImgLen"
                                @error="errLoad(index - 1)"
                                :src="List[index - 1]"
								
                            />
                            <span class="tag" v-if="levels[List[index - 1]]">{{levels[List[index - 1]]}}</span>
                        </div>
                    </transition-group>
                </draggable>
                <div style="height: 80px;"></div>
				<div class="little-icons" v-if="List.length > canDriveCount">
					<div
						v-for="index of List.length - canDriveCount"
						:key="index"
						class="img-box"
					>
						<img
							@load="computeLoadImgLen"
							@error="errLoad(index + canDriveCount - 1)"
							:src="List[index + canDriveCount - 1]"
						/>
						<!-- <img
							:src="
								'data:image/png;base64,' +
									List[index + 200 - 1].imgData
							"
							alt=""
						/> -->
					</div>
				</div>
				<div style="height: 40px;"></div>
		
            </div>
        </div>

        <div class="loading-show" v-show="showloading">
            <div class="lds-roller">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div>请稍后</div>
        </div>
        <div class="result">
            <img :src="img" alt="" srcset="" />
        </div>

        <ul class="show-img">
            <li><img src="../assets/index-1.png"/></li>
            <li><img src="../assets/index-2.png"/></li>
            <li><img src="../assets/index-3.png"/></li>
        </ul>
        <dialog-bar
            v-model="sendVal"
            type="confirm"
            title="添加编号、描述文字"
            @confirm="clickConfirm()"
            confirmText="确定"
        >
            <input class="desc-input" v-model="descVal" type="text" />
        </dialog-bar>
      <dialog-bar
          v-model="editLevel"
          type="confirm"
          title="请输入该饰品的等只级支持填写数字(1-10)"
          @confirm="levelConfirm()"
          confirmText="确定"
      >
        <input class="desc-input" v-model="level" type="number" max="10" min="1"/>
      </dialog-bar>
    </div>
</template>

<script>
import html2canvas from "html2canvas";
import { CreateImage, GetImageList } from "../server";
import draggable from "vuedraggable";
// import FileUpload from "vue-upload-component";
// @ is an alias to /src
import { Hosts } from "../unitl/config";
import DialogBar from "../components/dialog.vue";

var browser = {
    versions: (function() {
        var u = navigator.userAgent;
        return {
            //移动终端浏览器版本信息
            trident: u.indexOf("Trident") > -1, //IE内核
            presto: u.indexOf("Presto") > -1, //opera内核
            webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或者uc浏览器
            iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("iPad") > -1, //是否iPad
            webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
            weixin: u.indexOf("MicroMessenger") > -1, //是否微信
            qq: u.match(/\sQQ/i) == " qq" //是否QQ
        };
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
};
import {Falert, getStorageSync} from "../unitl/common";
import { constant } from "../unitl/constant";
export default {
    name: "Home",
    data() {
        return {
            showCreateLoading: false,
            pubgList: [],
            sendVal: false,
            levels: [],
            level: "",
            editLevel: false,
            editName: false,
            selected: "",
            descVal: "",
            steam: "",
            img: "",
            show_name: 1,
            showloading: false,
            showCreate: false,
            color: "#14202c",
            cdn_url: "",
            List: [],
            bgList: [],
            bgStyle: 0,
            imgLen: 0,
            file: "",
            pageIndex: 1,
            valuation: 0,
            iconIsFinish: false,
            bg: "",
			bg2:'',
            baseUrl: Hosts.host,
			showShuiyin:true,
			images:[],
			canDriveCount:350,
			txz_list:{},
			showScdj:false
        };
    },
	computed:{
		bodyStyle(){
			var backgroundImg='';
			var backgroundRepeat='';
			var bg=require('../assets/bg3.png');
			
			if(this.showShuiyin){
				backgroundImg=`url(${bg})`;
				backgroundRepeat='repeat-y';
			}
			if(this.bg){
				if(backgroundImg!=''){
					backgroundImg=backgroundImg+','+this.bg;
					backgroundRepeat=backgroundRepeat+','+(this.bgStyle ? 'repeat-y' : 'no-repeat');
				}else{
					backgroundImg=this.bg;
					backgroundRepeat=(this.bgStyle ? 'repeat-y' : 'no-repeat');
				}
			}
			let style={
				backgroundImage:backgroundImg,
				backgroundRepeat:backgroundRepeat,
				backgroundSize:'100%',
				backgroundColor:this.color
            }
			return style;
		}
	},
    components: {
        draggable,
        DialogBar
        // FileUpload,
    },
    watch: {
        pageIndex(val) {
            this.loadBackgounds(val);
        }
    },
    methods: {
        clickConfirm() {
            console.log("点击了confirm");
        },
        levelConfirm() {
          if(this.level>10||this.level<1){
            Falert("武器等级填写错误")
            return;
          }

          this.levels[this.selected]=this.level;
          console.log("点击了confirm");
        },
        changeBgStyle() {
            return (this.bgStyle = !this.bgStyle ? 1 : 0);
        },
        submit() {
            if (this.showloading) {
                return;
            }
            this.showloading = true;
            CreateImage(this.steam)
                .then(data => {
                    this.img = `data:image/jpeg;base64,${data.image}`;
                    this.showloading = false;
                })
                .catch(() => {
                    this.showloading = false;
                });
        },
        preview() {
            if (this.showloading) {
                return;
            }
            this.List = [];
            this.showCreate = false;
            this.showloading = true;
            this.img = "";
            GetImageList(this.steam)
                .then(data => {
					this.showScdj=false;
					this.txz_list=data.txz_list;
					data.inventory_list.sort(function(x,y){
						var sort=x['sort']-y['sort'];
						var sort2=x['valuation']-y['valuation'];
						if(sort>0){
							return -1;
						}else if(sort==0){
							if(sort2>0){
								return -1;
							}else if(sort2==0){
								return 0;
							}else{
								return 1;
							}
						}else{
							return 1;
						}
					})
					this.images=data.inventory_list;
                    this.loadBase64Img(data);
					
					var userInfo=JSON.parse(getStorageSync(constant.userInfo)||'{}');
					if(userInfo&&userInfo.shuiyin){
						this.showShuiyin=false;
					}
                })
                .catch(() => {
                    this.showloading = false;
                });
        },
		errLoad(idx){
			console.log('imageError',this.images[idx].name,this.images[idx].icon_url);
			this.computeLoadImgLen();
		},
        computeLoadImgLen() {
            this.imgLen += 1;
            if (this.imgLen === this.List.length) {
                this.iconIsFinish = true;
            }
        },
        getRandom(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min; //含最大值，含最小值
        },
        loadBase64Img(data) {
            this.showloading = false;
            this.showCreate = true;
            this.imgLen = 0;
            this.pubgList = [];
            let domainIndex = 0;

            this.List = data.inventory_list.map(element => {
     //            if (element.zh_name && element.zh_name.indexOf("通行证") > -1) {
					// console.log(element);
     //                if (!this.pubgList.includes(element.zh_name)) {
					// 	// open('http://assets1.weilaiwangluo.com/steam-image/'+element.icon_url);
     //                    this.pubgList.push(
     //                        require(`../assets/${element.zh_name}.jpg`)
     //                    );
     //                }
     //            }
				if(element.name=="BETTER LUCK NEXT TIME"){
					console.log(element);
					this.showScdj=true;
				}
				if(this.txz_list&&this.txz_list[element.name]){
					// this.pubgList.includes(element.zh_name)
					this.pubgList.push(this.txz_list[element.name].icon_url);
				}
				if(element['valuation']>10){
					// console.log(element['name'],element['sort'],element['valuation'])
				}
				
                this.valuation += element.valuation || 0;
                domainIndex += 1;
                if (domainIndex > 20) {
                    domainIndex = 1;
                }
                return ("http://steam-images.weilaiwangluo.com/economy/image/" +element.icon_url);
            });
        },
        uploadImg(ev) {
            const self = this;
            const file = ev.target;
            const reader = new FileReader();
            reader.readAsDataURL(file.files[0]);
            reader.onloadend = function(e) {
                self.bg = `url(${e.target.result})`;
                self.file = e.target.result;
            };
        },
        creatImg() {
          this.selected="";
          this.$nextTick(()=>{
            this.showloading = true;
            this.showCreate = false;
            this.showCreateLoading = true;
            let rect = this.$refs.capture.getBoundingClientRect();
            const rate = 4000 / rect.height;
            if (
                rate < 1 &&
                (browser.versions.mobile ||
                    browser.versions.ios ||
                    browser.versions.android ||
                    browser.versions.iPhone ||
                    browser.versions.iPad)
            ) {
                this.$refs.capture.style.transform = `scale(${rate})`;
                rect = this.$refs.capture.getBoundingClientRect();
            }
            
            const scrollTop =document.documentElement.scrollTop||window.pageYOffset || document.body.scrollTop;
            html2canvas(this.$refs.capture, {
                imageTimeout: 1000000,
                useCORS: true,
                x: Math.round(rect.x+(browser.versions.mobile?0:this.htmlCanvasAdjustX)),
                y: Math.round(rect.y),
                scrollY: -scrollTop,
                width: Math.round(rect.width-(browser.versions.mobile?0:this.htmlCanvasAdjustWidth)),
                height: Math.round(rect.height)
            }).then(canvas => {
                // 通过a标签下载到本地
                let link = document.createElement("a");
                link.href = canvas.toDataURL("image/jpeg");
                link.setAttribute("download", Date.now() + ".jpg");
                link.style.display = "none";
                document.body.appendChild(link);
                link.click();
                this.showCreate = true;
                this.showCreateLoading = false;
                this.showloading = false;
                this.$refs.capture.style.transform = `scale(1)`;
            });
          })
        },
        loadBackgounds(val) {
            this.bgList = [];
            for (let i = val * 10 - 9; i <= val * 10; i++) {
                this.bgList.push(require(`../assets/bg/list${i}.jpeg`));
                this.$forceUpdate();
            }
        },
        changeImage(val) {
          this.selected=val
        }
    },
    mounted() {
		this.loadBackgounds(this.pageIndex);
    }
};
</script>
<style>
.btn-item .m-colorPicker {
    width: 100%;
    height: 100%;
    display: flex !important;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.btn-item .m-colorPicker::before {
    content: "选择背景颜色";
    padding-right: 7px;
}
#app{
  overflow: visible !important;
}
</style>
<style scoped>

.radio {
    color: #ffffff;
    text-align: left;
}
.radio > input[type="radio"] {
    margin-left: 20px;
}
.kpw{
	overflow:hidden;  
	width: 280px;  
	height: 75px;
	top: 35px;  
	right: -68px;
	position: absolute;  
	transform: rotate(45deg);
	z-index:111;
}
.scdj{
	overflow:hidden; 
	width: 280px;  
	height: 75px;
	top: 35px;
	left: -68px;
	position: absolute;
	transform: rotate(-45deg);
	z-index:111
}
.scdj-text{
	line-height: 40px;
	position: absolute; 
	bottom:0; 
	display: block; 
	font-size:24px; 
	color:#F0F0F0;  
	width:280px; 
	text-align: center;
	height: 40px;
	background-color: #449eff;
	font-weight: bold;
}
h1 {
    margin-top: 140px;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    line-height: 28px;
}
.tips {
    padding-left: 20px;
    margin: 19px auto 0;
    width: 70px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(65, 194, 131, 1);
    line-height: 28px;
    background: url("../assets/green.png") left center no-repeat;
}
.search-box {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 60px;
}
.search-input {
    width: 510px;
    height: 46px;
    background: rgba(198, 212, 223, 1);
    border: none;
    outline: none;
    text-indent: 20px;
}
.search-input::placeholder {
    color: #869199;
}
.search-btn {
    width: 120px;
    height: 46px;
    background: rgba(44, 82, 129, 1);
    border: none;
    outline: none;
    color: #ffffff;
    font-size: 16px;
    cursor: pointer;
}
.bg-box {
    display: flex;
    height: 100px;
    margin-bottom: 30px;
    align-items: center;
    justify-content: center;
}

.bg-box img {
    height: 100%;
    cursor: pointer;
}
.how {
    padding-top: 26px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    text-decoration: underline;
    color: rgba(110, 173, 223, 1);
    line-height: 17px;
}
.show-img {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 235px;
    margin-bottom: 102px;
    overflow: hidden;
}
.show-img > li {
    margin-left: 20px;
}
.tag{
  z-index: 99;
  width: 45px;
  height: 26px;
  position: absolute;
  background: url('../images/level.png');
  background-size: 100%;
  color: #fff;
  right: 0;
  padding-right: 5px;
  font-size: 14px;
  font-weight: 600;
  text-align: right;
}
.tag img{
  width: 30px;
  height: 20px;
}
.result {
    margin-top: 20px;
}
.loading-show {
    margin-top: 30px;
    color: #ffffff;
}
.loader-01 {
    border: 0.2em dotted currentcolor;
    border-radius: 50%;
    -webkit-animation: 1s loader-01 linear infinite;
    animation: 1s loader-01 linear infinite;
    font-size: 14px;
    display: inline-block;
    width: 8px;
    height: 8px;
    color: inherit;
    vertical-align: middle;
    pointer-events: none;
    margin-left: 4px;
}
.create {
    display: flex;
    margin: 0 auto;
    padding-top: 100px;
    width: 1002px;
    flex-direction: column;
}
.create-l {
    padding-bottom: 24px;
    top: 0px;
    position: sticky;
    z-index:1000;
}
.txz-image{
	width: 280px;
	height: 130px;
}
.btn-item {
    color: #fff;
    height: 38px;
    border-radius: 4px;
    display: flex;
    width: 130px;
    align-items: center;
    justify-content: center;
    background: rgba(44, 82, 129, 1);
    position: relative;
    float: left;
    margin-right: 10px;
    cursor: pointer;
}
.btn-item.disable {
    background: #83b5e8;
}
.bg-2{
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 0;
	background-color: rgba(0,0,0,0);
	background-repeat: repeat-y;
	background-size: 100%;
}
.create-r {
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: left top;
    width: 1000px;
    border: 1px solid #ddd;
    overflow: hidden;
    position: relative;
    top: 0;
    display: flex;
    align-items: center;
    flex-direction: column;
}
.create-r .text-content {
    color: red;
    font-size: 24px;
}
.create-r .text-content div {
    font-size: 24px;
}
.little-icons {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
.little-icons .img-box {
    width: 61px;
    height: 61px;
    background: #3a3a3a;
    margin-bottom: 2px;
    padding: 4px;
}
.little-icons img {
    width: 100%;
    height: 100%;
}
.create-l > h3 {
    color: #ffffff;
    text-align: left;
    font-size: 16px;
    margin: 15px 0;
}
.desc-input {
    border: 1px solid #d7d7d7;
    height: 36px;
    width: 324px;
    padding: 0 10px;
    font-size: 15px;
    border-radius: 4px;
    margin-top: 30px;
}
.imgblock {
    width:135px;
	height: 135px;
    cursor: move;
  position: relative;
}
.imgblock:hover {
    box-shadow: 0px 0px 5px #2a3d50;
}
.imgblock > img {
    width: 100%;
}
.flip-list-move {
    transition: transform 1s;
}
.preview {
    display: flex;
    flex-wrap: wrap;
    width: 960px;
}
.create-btn {
    margin-top: 30px;
    width: 150px;
    height: 40px;
    line-height: 40px;
    border-radius: 2px;
    background: rgba(44, 82, 129, 1);
    color: #ffffff;
    font-size: 16px;
}
.uploadimg {
    background-color: #ffffff;
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
}
@keyframes loader-01 {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

.active{
  border: 1px dashed #fd931a;
}
</style>
